import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RouteData } from '@cigna/chcp/shared/util';
import { RouterFacade } from '@cigna/core/router-state';
import { map } from 'rxjs/operators';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-layout-public',
  templateUrl: './layout-public.component.html',
  styleUrls: ['./layout-public.component.scss'],
})
export class LayoutPublicComponent {
  routeData$ = this.routerFacade.data$ as Observable<RouteData>;
  isResourcePage$ = this.routeData$.pipe(
    map((data) => data.routeCode === 'resources'),
  );
  logoLink$ = this.isResourcePage$.pipe(
    map((isResourcePage) =>
      isResourcePage
        ? `${this.envConfig.api.gateways.cdn}assets/chcp/resourceLibrary/resourceLibrary.html`
        : '/login',
    ),
  );

  constructor(
    private routerFacade: RouterFacade,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {}
}
